import { React, useState } from "react";
import SUCheckComponent from "../signup/SUCheckComponent";
import SUComponent from "../signup/SUComponent";

export default function SignupPage() {
  const [step, setStep] = useState(1);

  return (
    <>
      {step == 1 ? (
        <SUCheckComponent setStep={setStep} />
      ) : (
        <SUComponent setStep={setStep} />
      )}
    </>
  );
}
